import { createContext } from 'react';
import EditTwitterConfigContext from 'types/contexts/EditTwitterConfigContext';

export default createContext({} as EditTwitterConfigContext);
